import React, { useState, useEffect } from "react";
import MiGif from "../../pikachu.gif";

const AnimatedGif = () => {
  const [position, setPosition] = useState({ x: 100, y: 100 });
  const [velocity, setVelocity] = useState({ dx: 3, dy: 3 });

  useEffect(() => {
    const moveGif = () => {
      setPosition((prev) => {
        let newX = prev.x + velocity.dx;
        let newY = prev.y + velocity.dy;

        // Tamaño de la pantalla y del GIF
        const screenWidth = window.innerWidth - 100; // Ajuste del tamaño del GIF
        const screenHeight = window.innerHeight - 100;

        let newDx = velocity.dx;
        let newDy = velocity.dy;

        // Rebotar en los bordes
        if (newX <= 0 || newX >= screenWidth) newDx = -newDx;
        if (newY <= 0 || newY >= screenHeight) newDy = -newDy;

        setVelocity({ dx: newDx, dy: newDy });

        return { x: newX, y: newY };
      });
    };

    const interval = setInterval(moveGif, 20); // Ajusta la velocidad

    return () => clearInterval(interval);
  }, [velocity]);

  return (
    <img
      src={MiGif}
      alt="Cargando..."
      style={{
        position: "absolute",
        left: `${position.x}px`,
        top: `${position.y}px`,
        width: "230px",
        height: "200px",
      }}
    />
  );
};

const App = () => {
  return (
    <div>
      <AnimatedGif />
    </div>
  );
};

export default App;
